function foodguruShippingRate(zipcode) {
  let bangkok_postcodes = [
    '10100',
    '10600',
    '10510',
    '10230',
    '10900',
    '10150',
    '10210',
    '10400',
    '10300',
    '10170',
    '10170',
    '10140',
    '10700',
    '10240',
    '10150',
    '10220',
    '10120',
    '10160',
    '10800',
    '10260',
    '10150',
    '10700',
    '10500',
    '10240',
    '10250',
    '10330',
    '10100',
    '10400',
    '10260',
    '10200',
    '10160',
    '10510',
    '10140',
    '10520',
    '10230',
    '10310',
    '10110',
    '10240',
    '10100',
    '10220',
    '10160',
    '10530',
    '10210'
  ]

  var rate = ''

  if (bangkok_postcodes.includes(zipcode.toString())) {
    rate = 'BKK'
  } else {
    rate = 'OTHER'
  }

  return rate
}

function foodguruCalShippingPrice(
  rate,
  shippingtype,
  totalamount,
  distance = null
) {
  var price
  if (rate == 'BKK') {
    if (shippingtype == 'scgexpress_charge') {
      if (totalamount >= 1500) {
        price = 0
      } else {
        price = 150
      }
    } else if (shippingtype == 'flash_charge') {
      if (totalamount >= 1500) {
        price = 0
      } else {
        price = 50
      }
    } else {
      //Skootar
      if (distance) {
        if (distance <= '2.99') {
          price = 40
        } else if (distance < '4.00') {
          price = 45
        } else if (distance < '5.00') {
          price = 50
        } else if (distance < '6.00') {
          price = 55
        } else if (distance < '7.00') {
          price = 62
        } else if (distance < '8.00') {
          price = 69
        } else if (distance < '9.00') {
          price = 76
        } else if (distance < '10.00') {
          price = 83
        } else if (distance >= '10.00') {
          var diff = Math.floor(distance - 10).toFixed(2)
          var diffPrice = diff * 10
          price = parseInt(93 + diffPrice).toFixed(2)
        } else {
          // distance > 10.00
          price = false
        }
      }
    }
  } else {
    // rate = OTHER
    if (shippingtype == 'scgexpress_charge') {
      if (totalamount >= 4000) {
        price = 0
      } else {
        price = 270
      }
    } else if (shippingtype == 'flash_charge') {
      if (totalamount >= 4000) {
        price = 0
      } else {
        price = 50
      }
    } else {
      price = false
    }
  }
  return price
}

export { foodguruShippingRate, foodguruCalShippingPrice }
